import { render, staticRenderFns } from "./DispensationFormFiles.vue?vue&type=template&id=670423d6&scoped=true&"
import script from "./DispensationFormFiles.vue?vue&type=script&lang=js&"
export * from "./DispensationFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./DispensationFormFiles.vue?vue&type=style&index=0&id=670423d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670423d6",
  null
  
)

export default component.exports